export function StarRating({ rating, count, size = "sm" }) {
  const normalized = Number(rating || 0).toFixed(1);
  return (
    <div className="flex items-baseline gap-1.5 font-body" aria-label={`${normalized} out of 5${count ? ` from ${count} reviews` : ""}`}>
      <span className={`font-bold text-navy ${size === "md" ? "text-lg" : "text-sm"}`}>{normalized} / 5</span>
      {count != null && <span className="text-gray-500 text-xs">({Number(count).toLocaleString()})</span>}
    </div>
  );
}